import fetchApi from "./fetchApi";
import { actionTypes, FetchProductInfo } from "./Actions";

const fetchUpsaleProductInfo: FetchProductInfo = productId =>
  fetchApi(
    `/bestilling/api/v2/ff/product/${productId}.json`,
    actionTypes.SET_UPSALE_PRODUCT_INFO
  );

export default fetchUpsaleProductInfo;
